module.exports = __webpack_public_path__ + "fonts/icomoon.104c2c7.eot";